<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15EXaKu/tc-custom/9781459206717.jpg?1726444229060" alt="This image is the cover for the book Playboy King's Wife, Kings of the Outback"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Playboy King's Wife, Kings of the Outback
      </h1>
      <p class="bookDescription body article font2">
        <p>Samantha Connelly finally knows what it is to feel sexy, elegant—and <i>desirable</i>. Playboy Tommy King, the man she has secretly loved for years, is amazed at her transformation.<br/><br/>Up to now, Sam and Tommy have clashed head-on. Suddenly the friction deepens into fiery sexual attraction. But is this just another game for Tommy to win…or will Sam be the woman he marries?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emma Darcy
      </h2>
      
      <p class="authorDescription body article">Initially a French/English teacher, Emma Darcy changed careers to computer programming before the happy demands of marriage and motherhood. Very much a people person, and always interested in relationships, she finds the world of romance fiction a thrilling one and the challenge of creating her own cast of characters very addictive.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f5d1c6ae